import { clsx } from 'clsx'

import { Figcaption } from './Figcaption.js'
import { ImageAlt } from './ImageAlt.js'
import { AsyncImageAttributes, ImageDescriptionType } from './types.js'
import { convertFigureDataAttributesToClassname } from './utils.js'

export function AsyncImageNodeView(nodeAttrs: AsyncImageAttributes) {
  const {
    loading,
    size,
    align,
    src,
    app,
    id,
    hasDescription,
    description,
    descriptionType,
  } = nodeAttrs as AsyncImageAttributes
  const nodeClassNames = convertFigureDataAttributesToClassname({
    align,
    size,
    hasCaption: descriptionType === ImageDescriptionType.Caption,
    app,
  })

  const shouldRenderDescription = hasDescription && !!description

  const hasAlt =
    descriptionType === ImageDescriptionType.Alt && shouldRenderDescription
  const hasCaption =
    descriptionType === ImageDescriptionType.Caption && shouldRenderDescription
  const hasOverlayCaption =
    descriptionType === ImageDescriptionType.Overlay && shouldRenderDescription

  return (
    <figure
      className={clsx(nodeClassNames, loading && 'opacity-90 animate-pulse')}
      data-type="image"
      data-id={id}
      data-app={app}
      data-size={size}
      data-align={align}
    >
      <img
        src={src}
        alt={hasAlt ? description : undefined}
        data-id={id}
        data-app={app}
        className="rounded-base"
      />
      {(hasCaption || hasOverlayCaption) && (
        <Figcaption asOverlay={hasOverlayCaption}>{description}</Figcaption>
      )}
      {hasAlt && <ImageAlt description={description} imageId={id} />}
    </figure>
  )
}
